export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    question: '萝幼社是什么？',
    answer: '萝幼社是一个专注于二次元文化的正版授权内容平台。我们汇聚了海量优质的插画、漫画、同人创作、Cosplay、声优配音和动画短片等二次元内容，为广大二次元爱好者提供一站式的视觉内容与社区互动体验。',
  },
  {
    id: 'faq-2',
    question: '如何成为萝幼社的创作者？',
    answer: '我们欢迎所有热爱二次元创作的艺术家加入萝幼社！您可以通过官网的"加入我们"页面提交申请，上传您的代表作品。我们的内容审核团队会在 3-5 个工作日内完成审核，通过后您就可以在平台上发布作品了。',
  },
  {
    id: 'faq-3',
    question: '萝幼社的内容都是正版授权的吗？',
    answer: '是的，萝幼社始终坚持正版授权原则。平台上的所有原创内容均获得创作者的正版授权，同人创作也严格遵守相关版权法规。我们致力于为创作者提供公平的创作环境，为用户提供优质的合法内容。',
  },
  {
    id: 'faq-4',
    question: '如何下载或保存平台上的作品？',
    answer: '为了保护创作者的权益，平台上的作品暂不提供直接下载功能。您可以在线浏览和收藏喜欢的作品。部分创作者可能会在作品描述中提供个人主页或社交平台链接，您可以通过这些渠道获取更多内容。',
  },
  {
    id: 'faq-5',
    question: '萝幼社的会员有哪些权益？',
    answer: '萝幼社会员可以享受专属高清内容浏览、优先观看最新连载、参与创作者互动活动、获得限定周边商品购买资格等多项权益。我们会不定期推出会员专属活动，为会员带来更多惊喜。',
  },
  {
    id: 'faq-6',
    question: '发现了侵权内容应该怎么办？',
    answer: '萝幼社高度重视版权保护。如果您在平台上发现任何涉嫌侵权的内容，请通过"联系我们"页面或发送邮件至 copyright@luoyoushe.com 进行举报。我们会在收到举报后 24 小时内启动调查程序，并根据调查结果采取相应措施。',
  },
];